export class AssetCategory {
  id: number = -1;
  name: string = '';
  entity:string = '';
  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
